/*
 * Filename: onInit-invoke-rule.controller.ts
 * Description: Controller for oninit invoke action rule
 */

import { CQAppConstant } from '../../../app-constants';


export class CQOnInitInvokeActionRuleController {
    // public targetFieldApiName = '';
    // public fields: string[] = [];
    // public filter = '';
    public ruleJSON: any = {};

    constructor(ruleObject: any) {
        this.formRuleJson(ruleObject);
    }

    /**
     * @private
     * @memberof CQOnInitInvokeActionRuleController
     */
    private formRuleJson = (invokeActionRuleData: any) => {

        const actions = invokeActionRuleData.actions.map((action: any) => action.action);
        const componentRule: any = CQAppConstant.COMPONENT_EVENT_RULES_MAP;
        this.ruleJSON = {
            [componentRule.onInitInvoke.key]: { onInit: { 'invoke': { action: actions } } }
        };
        return this.formRuleJson;
    }
}

